import { render } from "./SerieBoardItem.vue?vue&type=template&id=54dcfddc"
import script from "./SerieBoardItem.vue?vue&type=script&lang=js"
export * from "./SerieBoardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__